import CoursesItemsService from "@/services/CoursesItemsService";

const state = {
  course: {},
  courseItems: [],
};

class CoursesItems {
  constructor(rawItem) {
    this.title = rawItem.title;
    this.id = rawItem.id;
    this.name = rawItem.name;
    this.hasMessages = rawItem.has_messages;
    this.isActive = false;
  }

  setIsActive(val) {
    this.isActive = val;
  }
}

const getters = {
  getCourses: (state) => {
    return state.courseItems;
  },
};

const actions = {
  async getItems({ commit }) {
    const response = await CoursesItemsService.listOfCourse();
    const items = response.data.results;

    commit("setCourseItems", items);
  },
};

const mutations = {
  setCourseItems(state, rawCourseItems) {
    state.courseItems = rawCourseItems.map((rawCourseItem) => {
      return new CoursesItems(rawCourseItem);
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
